









































































































































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import CatalogTile from '@/components/CatalogTile';
import CatalogHorizontalTile from '@/components/CatalogHorizontalTile';
import EmptyCatalog from '@/components/EmptyCatalog';
import Pagination from '@/components/Pagination';
import {mapGetters} from 'vuex';

@Component({
  name: 'CatalogList',
  components: {
    CatalogHorizontalTile, CatalogTile,
    EmptyCatalog, Pagination,
  },
  props: {
    countItems: {
      type: Number,
      default: 0,
    },
    countTitle: {
      type: String,
      default: '',
    },
    clearText: {
      type: String,
      default: '',
    },
    sortCount: {
      type: Object,
      default: () => {},
    },
    sortTypes: {
      type: Object,
      default: () => {},
    },
    allApartments: {
      type: Array,
      default: () =>  [],
    },
    emptyCatalog: {
      type: Object,
      default: () =>  {},
    },
    mobileTitleText: {
      type: String,
      default: '',
    },
    mobileBtnText: {
      type: String,
      default: '',
    },
    nextPageLink: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    page_size: {
      type: Number,
      default: 0,
    },
    ordering: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 1,
    },
    initEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actualSortType: this.ordering,
      actualSortCount: this.page_size,
      listCatalog: false,
      showSortPopup: false,
      widthMult: 0,
      widthTile: null,
    };
  },
  computed: {
    ...mapGetters('catalog', ['pagination', 'catalogItem']),
  },
  methods: {
    sortList(type, value) {
      type === 'count' ? this.actualSortCount = value : this.actualSortType = value;
      const data = {
        ordering: this.actualSortType,
        page_size: this.actualSortCount,
      };
      this.$emit('updateApartments', data);
    },

    sortItemsPopup(type, value) {
      this.showSortPopup = false;
      this.sortList(type, value);
    },

    clearAllFilters() {
      this.$emit('clearFilters');
    },

    updateActualPage(data) {
      this.$emit('updateApartments', data);
    },

    addApartmentsPage(data) {
      this.$emit('addedApartmentsToPage', data);
    },
  },
})
export default class CatalogList extends Vue {
}
